import { zUid } from "src/types/zUid";
import { z } from "zod";

export const zMesChartSettings = z.object({
  mcServiceId: zUid,
  objectId: zUid,

  mcObjectId: zUid.nullable(),
  mcNameAttrId: zUid.nullable(),
  mcModelAttrId: zUid.nullable(),
  mcSizeScaleAttrId: zUid.nullable(),
  mcBaseSizeAttrId: zUid.nullable(),
  mcCommentAttrId: zUid.nullable(),
  mcMcPointAttrId: zUid.nullable(),
  mcImageAttrId: zUid.nullable(),

  sizeLinesObjectId: zUid.nullable(),
  sizeLinesNameAttrId: zUid.nullable(),
  sizeLinesSizeLineSizeAttrId: zUid.nullable(),

  sizeLineSizeObjectId: zUid.nullable(),
  sizeLineAttrId: zUid.nullable(),
  sizeLineSizeNameAttrId: zUid.nullish(),
  sizeLineSizePreviousSizeAttrId: zUid.nullable(),

  msPointsObjectId: zUid.nullable(),
  msPointsMcAttrId: zUid.nullable(),
  msPointsPointAttrId: zUid.nullable(),
  msPointsDescriptionAttrId: zUid.nullable(),
  msPointsQcAttrId: zUid.nullable(),
  msPointsTolMinusAttrId: zUid.nullable(),
  msPointsTolPlusAttrId: zUid.nullable(),
  msPointsPointValueAttrId: zUid.nullable(),
  msPointsResizeValueMinusAttrId: zUid.nullable(),
  msPointsResizeValuePlusAttrId: zUid.nullable(),
  mcPointCategoryAttrId: zUid.nullable(),

  pointObjectId: zUid.nullable(),
  pointPointNameAttrId: zUid.nullable(),
  pointDescriptionAttrId: zUid.nullable(),

  sizeNameObjectId: zUid.nullable(),
  sizeNameNameAttrId: zUid.nullable(),
  sizeNameSynonymsAttrId: zUid.nullable(),

  // Point value settings
  pointValueObjectId: zUid.nullable(),
  pointValueMcPointsAttrId: zUid.nullable(),
  pointValueSizeAttrId: zUid.nullable(),
  pointValueVersionAttrId: zUid.nullable(),
  pointValueValueAttrId: zUid.nullable(),

  // Version
  versionDictionaryNameAttrId: zUid.nullable(),

  templateObjectId: zUid.nullable(),
});

export type ZMesChartSettings = z.infer<typeof zMesChartSettings>;
